import { render, staticRenderFns } from "./ProfileNav.vue?vue&type=template&id=313a1168&scoped=true"
import script from "./ProfileNav.vue?vue&type=script&lang=js"
export * from "./ProfileNav.vue?vue&type=script&lang=js"
import style0 from "./ProfileNav.vue?vue&type=style&index=0&id=313a1168&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313a1168",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('313a1168')) {
      api.createRecord('313a1168', component.options)
    } else {
      api.reload('313a1168', component.options)
    }
    module.hot.accept("./ProfileNav.vue?vue&type=template&id=313a1168&scoped=true", function () {
      api.rerender('313a1168', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/sidebar/ProfileNav.vue"
export default component.exports